module.exports = `${require.publicPath}logo.172408e9.png`;